var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuantique(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 49,
    viewBox: "0 0 240 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_327_95)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.2384 32.0783H68.5161C65.0391 32.0783 63.3105 30.2797 63.3105 26.6727V5.49463C63.3105 1.82825 65.0292 0 68.4763 0H72.6089C76.0561 0 77.7747 1.82825 77.7747 5.49463V28.1946H80.2483V32.0783H80.2384ZM73.4534 28.1946V5.76145C73.4534 4.50638 72.8076 3.88379 71.5261 3.88379H69.5095C68.2478 3.88379 67.622 4.50638 67.622 5.76145V26.3169C67.622 27.572 68.2677 28.1946 69.5492 28.1946H73.4534Z",
    fill: "#070707"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.763 0V26.0007C100.763 30.0524 99.0241 32.0783 95.5571 32.0783H91.9211C88.474 32.0783 86.7554 30.0426 86.7554 25.9611V0H91.0668V26.0995C91.0668 27.5028 91.6927 28.2044 92.9543 28.2044H94.7027C95.875 28.2044 96.4511 27.5028 96.4511 26.0995V0H100.763Z",
    fill: "#070707"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.379 32.0783H109.067V5.49463C109.067 1.82825 110.786 0 114.233 0H117.472C120.919 0 122.637 1.82825 122.637 5.49463V32.0783H118.326V20.3281H113.389V32.0783H113.379ZM118.316 16.4345V5.76145C118.316 4.50638 117.69 3.88379 116.429 3.88379H115.266C114.005 3.88379 113.379 4.50638 113.379 5.76145V16.4444H118.316V16.4345Z",
    fill: "#070707"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.883 15.5055V0H144.195V32.0783H139.883V25.6844L135.254 11.0683V32.0685H130.942V0H135.254L139.883 15.5055Z",
    fill: "#070707"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.603 3.88379V32.0783H155.291V3.88379H151.159V0H163.735V3.88379H159.603Z",
    fill: "#070707"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.699 32.0783V0H175.011V32.0783H170.699Z",
    fill: "#070707"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.253 32.0783H188.531C185.054 32.0783 183.325 30.2797 183.325 26.6727V5.49463C183.325 1.82825 185.044 0 188.491 0H192.624C196.071 0 197.789 1.82825 197.789 5.49463V28.1946H200.263V32.0783H200.253ZM193.468 28.1946V5.76145C193.468 4.50638 192.822 3.88379 191.541 3.88379H189.524C188.262 3.88379 187.637 4.50638 187.637 5.76145V26.3169C187.637 27.572 188.282 28.1946 189.564 28.1946H193.468Z",
    fill: "#070707"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.777 0V26.0007C220.777 30.0524 219.039 32.0783 215.572 32.0783H211.936C208.489 32.0783 206.77 30.0426 206.77 25.9611V0H211.081V26.0995C211.081 27.5028 211.707 28.2044 212.969 28.2044H214.717C215.89 28.2044 216.466 27.5028 216.466 26.0995V0H220.777Z",
    fill: "#070707"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.311 32.0783V0H240V3.88379H233.622V13.6279H239.284V17.5117H233.622V28.1946H240V32.0783H229.311Z",
    fill: "#070707"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.0732 41.8027H89.07L90.6793 44.8662L92.2589 41.8027H94.2855V48.7401H92.845V43.8286H92.8251L91.2754 46.9909H90.0932L88.5534 43.878H88.5336V48.7401H87.0732V41.8027Z",
    fill: "#070707"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.0341 45.973V47.4455H102.968V48.7302H97.5439V41.773H102.63V43.0577H99.0241V44.6191H102.213V45.973H99.0241H99.0341Z",
    fill: "#070707"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.776 43.0874H105.561V41.8126H111.511V43.0973H109.316V48.7401H107.786V43.0874H107.776Z",
    fill: "#070707"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.962 48.75L116.131 41.8224H117.671L120.79 48.75H119.31L118.624 47.2183H115.098L114.363 48.75H112.962ZM116.916 43.1269L115.743 45.8051H118.058L116.926 43.1269H116.916Z",
    fill: "#070707"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.462 41.8027H126.472C128.28 41.8027 129.641 42.9392 129.641 45.2319C129.641 47.2479 128.608 48.7401 126.472 48.7401H123.462V41.8027ZM124.992 47.4554H126.363C127.247 47.4554 128.102 46.9119 128.102 45.3801C128.102 43.9768 127.605 43.0874 126.085 43.0874H124.992V47.4653V47.4554Z",
    fill: "#070707"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.996 48.75L135.165 41.8224H136.705L139.824 48.75H138.334L137.648 47.2183H134.122L133.387 48.75H131.986H131.996ZM135.95 43.1269L134.777 45.8051H137.092L135.96 43.1269H135.95Z",
    fill: "#070707"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.549 43.0874H141.334V41.8126H147.285V43.0973H145.089V48.7401H143.559V43.0874H143.549Z",
    fill: "#070707"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.725 48.75L151.894 41.8224H153.433L156.553 48.75H155.073L154.387 47.2183H150.86L150.125 48.75H148.725ZM152.678 43.1269L151.506 45.8051H153.821L152.688 43.1269H152.678Z",
    fill: "#070707"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.143 41.8027H167.292C169.04 41.8027 169.706 42.8996 169.706 44.0262C169.706 45.1528 169.04 46.2498 167.292 46.2498H165.682V48.7401H164.153V41.8027H164.143ZM165.672 45.0639H166.865C167.57 45.0639 168.216 44.9058 168.216 44.0262C168.216 43.1467 167.57 42.9886 166.865 42.9886H165.672V45.0639Z",
    fill: "#070707"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.865 48.75H174.137L171.872 41.8126H173.451L175.001 46.6945H175.021L176.59 41.8126H178.17L175.855 48.75H175.865Z",
    fill: "#070707"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.491 43.0874H180.276V41.8126H186.226V43.0973H184.031V48.7401H182.501V43.0874H182.491Z",
    fill: "#070707"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.826 48.7006V41.7829H195.326V47.4159H198.903V48.7006H193.826Z",
    fill: "#070707"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.492 43.0874H201.277V41.8126H207.227V43.0973H205.032V48.7401H203.502V43.0874H203.492Z",
    fill: "#070707"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.059 41.8027H213.069C214.877 41.8027 216.238 42.9392 216.238 45.2319C216.238 47.2479 215.204 48.7401 213.069 48.7401H210.059V41.8027ZM211.588 47.4554H212.959C213.853 47.4554 214.698 46.9119 214.698 45.3801C214.698 43.9768 214.201 43.0874 212.681 43.0874H211.588V47.4653V47.4554Z",
    fill: "#070707"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.3431 0.0197754H0V48.7204H49.3431L37.0048 36.5452H12.3383V12.1949H37.0048V36.5452H49.3431V0.0197754Z",
    fill: "#070707"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_327_95"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 240,
    height: 48.75,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuantique);
export default __webpack_public_path__ + "static/media/quantique.22372f8536ea84f00db86a08f36b43c7.svg";
export { ForwardRef as ReactComponent };